import { render, staticRenderFns } from "./ContactInfoPreview.vue?vue&type=template&id=31f2ace6"
import script from "./ContactInfoPreview.vue?vue&type=script&lang=js"
export * from "./ContactInfoPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports